import { computed, nextTick, ref } from 'vue';

import { defineStore } from 'pinia';

import { AUTH_COOKIE_NAME, getAuthCookieOptions } from '~~/util/auth-cookie';

export const useAuthStore = defineStore(
  'auth', 
    () => {
    // store
    const data = ref({
      user: {},
      userRoles: []
    });
    
    // actions
    function login(payload) {
      data.value.user = payload;
    }
    async function logout() {
      data.value.user = {};

      // Drops the api_token from the cookie synchronously, before we await anything.
      this.$persist();

      // Remove the cookie entirely. The persist plugin's $subscribe handler is
      // pre-flush, so it would otherwise re-write an empty husk right after we
      // deleted it — wait for that flush, then delete, then let useCookie's own
      // (also pre-flush) watcher write the removal out.
      if (import.meta.client) {
        await nextTick();
        useCookie(AUTH_COOKIE_NAME, getAuthCookieOptions()).value = null;
        await nextTick();
      }
    }
    function setUser(payload) {
      data.value.user = payload;
    }
    function setUserRoles(payload) {
      data.value.userRoles = payload;
    }

    // getters
    const user = computed(() => {
      return data.value.user
    });
    const apiToken = computed(() => {
      return data.value.user ? data.value.user.api_token : undefined;
    });
    const userRole = computed(() => {
      return data.value.user && Array.isArray(data.value.user.roles) 
        ? data.value.user.roles[0] 
        : undefined;
    });
    const isAdmin = computed(() => {
      return userRole.value && userRole.value.slug === 'admin';
    });
    const isContributor = computed(() => {
      return userRole.value && userRole.value.slug === 'contributor';
    });
    const isObserver = computed(() => {
      return userRole.value && userRole.value.slug === 'observer';
    });
    const isLoggedIn = computed(() => {
      return !!data.value.user && !!data.value.user.api_token;
    });
    const userRoles = computed(() => {
      return data.value.userRoles;
    });

    return { data, login, logout, setUser, setUserRoles, user, apiToken, userRole, isAdmin, isContributor, isObserver, isLoggedIn, userRoles }
  },
  {
    persist: {
      enabled: true,
      key: AUTH_COOKIE_NAME,
      paths: ['data.user'],
      storage: persistedState.cookiesWithOptions(getAuthCookieOptions()),
    },
  }
)
